export const PAGE_NAME = "application-page";
